module.exports = __webpack_public_path__ + "static/media/17b Crossface.17223346.jpg";